import { useEffect, useState } from "react";
import { api, ApiError } from "../lib/api";
import { openPackLink } from "../lib/telegram";

interface MissingChannel {
  channel_id: number;
  title: string;
  link: string | null;
}

interface SubscriptionStatus {
  required: boolean;
  all_subscribed: boolean;
  missing_channels: MissingChannel[];
}

export function SubscriptionGate({ children }: { children: React.ReactNode }) {
  const [status, setStatus] = useState<SubscriptionStatus | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [checking, setChecking] = useState(false);

  const fetchStatus = () => {
    setError(null);
    api
      .get<SubscriptionStatus>("/api/subscription/status")
      .then(setStatus)
      .catch((err) => setError(err instanceof ApiError ? err.message : "تعذر التحقق من الاشتراك"));
  };

  useEffect(() => {
    fetchStatus();
  }, []);

  const handleCheckAgain = () => {
    setChecking(true);
    api
      .get<SubscriptionStatus>("/api/subscription/status")
      .then(setStatus)
      .catch((err) => setError(err instanceof ApiError ? err.message : "تعذر التحقق من الاشتراك"))
      .finally(() => setChecking(false));
  };

  // Still loading, or the check failed (e.g. TDLib not attached yet) -
  // don't block the app on a transient backend hiccup; just show the
  // app normally and let the server-side enforcement on finalize/pack
  // actions catch anything that truly matters.
  if (!status || error) {
    return <>{children}</>;
  }

  if (!status.required || status.all_subscribed) {
    return <>{children}</>;
  }

  return (
    <div className="app-shell flex flex-col items-center justify-center p-6 text-center gap-5">
      <span className="text-5xl">📢</span>
      <div>
        <h1 className="text-lg font-bold mb-1">اشترك بالقنوات التالية أولاً</h1>
        <p className="text-sm text-tg-hint">لازم تشترك بهذي القنوات عشان تقدر تستخدم الاستوديو</p>
      </div>

      <div className="w-full flex flex-col gap-2">
        {status.missing_channels.map((ch) => (
          <button
            key={ch.channel_id}
            type="button"
            onClick={() => ch.link && openPackLink(ch.link)}
            className="flex items-center justify-between bg-tg-secondaryBg rounded-xl px-4 py-3"
          >
            <span>{ch.title}</span>
            <span className="text-tg-link text-sm">انضم ›</span>
          </button>
        ))}
      </div>

      <button
        type="button"
        onClick={handleCheckAgain}
        disabled={checking}
        className="w-full py-3 rounded-xl bg-tg-button text-tg-buttonText font-semibold disabled:opacity-50"
      >
        {checking ? "جاري التحقق..." : "تحقق الآن"}
      </button>
    </div>
  );
}
